import React from 'react';
import styles from './local-image-thumb.scss';

interface Props {
  file: File;
  width: number;
  height: number;
}

export class LocalImageThumb extends React.PureComponent<Props> {
  private readonly objectURL: string;

  constructor(props) {
    super(props);

    this.objectURL = window.URL.createObjectURL(this.props.file);
  }

  private revokeObjectURL() {
    window.URL.revokeObjectURL(this.objectURL);
  }

  public render() {
    const { width, height } = this.props;

    return (
      <div style={{ width, height }}>
        <img
          className={styles.image}
          src={this.objectURL}
          onLoad={this.revokeObjectURL.bind(this)}
        />
      </div>
    );
  }
}
